import { render, staticRenderFns } from "./EvalProfileCompare.vue?vue&type=template&id=f116620c&"
import script from "./EvalProfileCompare.vue?vue&type=script&lang=js&"
export * from "./EvalProfileCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports